import debug from 'debug'
import { stringify } from 'qs'

const logger = debug('web-view')

export const sendEvent = (params: object) => {
  const uri = `acorns://event?${stringify(params)}`

  logger(`Sending event to web view: ${uri}`)

  window.location.assign(uri)
}
